import { Component, Input, ElementRef, AfterViewInit, OnChanges } from '@angular/core';

@Component({
  moduleId: module.id.toString(),
  selector: 'app-help',
  templateUrl: 'help.component.html',
  styleUrls: ['help.component.css']
})

export class HelpComponent implements AfterViewInit, OnChanges {
  @Input() content: string = '';
  tooltipContent: string = '';

  constructor(private elementRef: ElementRef) { }

  ngOnChanges() {
    if (this.content) {
      this.tooltipContent = this.content;
    }
  }

  ngAfterViewInit() {
    if (!this.content) {
      this.tooltipContent = this.elementRef.nativeElement.textContent.trim();
    } else {
      this.tooltipContent = this.content;
    }
  }
}
